import { HeaderBlockProps, HeaderBlockType } from '@stadionhq-v3/base-ui';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { HeaderBlock, Link } from '@graphql/__generated__/graphql';
import { Theme } from '@stadionhq-v3/core';
import { Locale } from '@core/constants/locales.constants';
import { Translations } from '@lib/dictionary-keys/__generated__';
import { renameKeyFromTitleToText } from '@utils/objects.utils';
import { isLink } from '@core/types/typeGuards';
import { ArrowLeft } from '../../../../components/icons';
import { linkTransform } from '../atoms';
import { assetTransform } from '../atoms/asset.transform';

export type HeaderBlockTransformSettings = {
  useNextImage?: boolean;
  onDark?: boolean;
  displayImage?: boolean;
  displayLink?: boolean;
  displaySubNav?: boolean;
  hideBackButton?: boolean;
  backButtonUrl?: string;
};

const headerBlockTransform = (
  {
    id,
    title,
    section,
    summary,
    theme,
    type,
    sponsor,
    // backButton,
    // pageNavPreviousButton,
    // pageNavNextButton,
    subNav,
    image,
    link,
  }: CleanContentful<HeaderBlock>,
  locale: Locale,
  dictionary: {
    previousAction: Translations['common']['action']['previous'];
    nextAction: Translations['common']['action']['next'];
    sponsoredBy: Translations['common']['label']['sponsoredBy'];
    backButton: Translations['navigation']['action']['backButton'];
  },
  settings?: HeaderBlockTransformSettings
): HeaderBlockProps => ({
  id,
  title,
  section,
  summary,
  theme: (theme as Theme) || undefined,
  type: type as HeaderBlockType,
  ...(!settings?.hideBackButton && {
    backButton: {
      url: settings?.backButtonUrl || '',
      title: dictionary.backButton,
      text: dictionary.backButton,
      iconBefore: <ArrowLeft />,
    },
  }),
  pageNavPreviousButton: {
    text: dictionary.previousAction,
  },
  pageNavNextButton: {
    text: dictionary.nextAction,
  },
  subNav: subNav?.links
    ?.filter(isLink)
    .map((navLink) => linkTransform(navLink as CleanContentful<Link>, locale)),
  // @ts-expect-error - TODO: fix when LinkProps aligned with ButtonProps
  link: link?.url && renameKeyFromTitleToText(linkTransform(link, locale)),
  sponsor: sponsor && {
    title: dictionary.sponsoredBy,
    image: sponsor && <ContentfulImage {...assetTransform(sponsor)} />,
    imagePosition: 'right',
    onDark: settings?.onDark,
  },
  image: image && <ContentfulImage {...image} />,
  // Maybe These should be in the transform - they just need to be static props passed through to the component
  onDark: settings?.onDark,
  displayImage: settings?.displayImage,
  displayLink: settings?.displayLink,
  displaySubNav: settings?.displaySubNav,
});

export default headerBlockTransform;
